
import { getGlobalLocale } from "./localStoreLoc";

export default function numberFormat(value,) {
    const locale = getGlobalLocale() || "en-IN";
    console.log({ locale })
    return value;
}
